import Vue from "vue";
import Router from "vue-router";

import Acceso from "./views/Acceso.vue";
import Detalle from "./views/Detalle.vue";
import Imagen from "./views/Imagen.vue";
import Error404 from "./views/Error404.vue";
import Mantenimiento from "./views/Mantenimiento.vue";
import Resumen from "./views/Resumen.vue";
import Sistema from "./views/Sistema.vue";

Vue.use(Router);

export default new Router({
    base: process.env.BASE_URL,
    mode: "history",
    routes: [
        { path: "/", name: "acceso", component: Acceso },
        { path: "/acceso/", name: "acceso2", component: Acceso },
        { path: "/detalle/:systemId", name: "detalle", component: Detalle },
        { path: "/imagen/:url", name: "imagen", component: Imagen },
        { path: "/mantenimiento/:systemId", name: "mantenimiento", component: Mantenimiento },
        { path: "/resumen/", name: "resumen", component: Resumen },
        { path: "/sistemanuevo", name: "sistemanuevo", component: Sistema },
        { path: "/sistema/:systemId", name: "sistema", component: Sistema },
        { path: "*", component: Error404 }
    ]
});
